import { useState } from "react";
import Button from "../../../components/Button";
import { verifyLicenseKey } from "../api/paymentRequest";
import { useTranslation } from "../../../i18n/TranslationProvider";

// Lets a user verify an existing license key instead of purchasing a plan.
// On success, tells the parent (Payment.js) so it can redirect like it does for hasPaid.
const LicenseKeyInput = ({ userId, setVerified, setLicenseEndDate, standalone = false }) => {
    const [licenseKey, setLicenseKey] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const handleVerifyKey = async () => {
        try {
            setLoading(true);
            const response = await verifyLicenseKey({ userId, licenseKey });

            if (response.status === 200) {
                setVerified(true);
            }

            if (response.data?.endDate) {
                setLicenseEndDate(response.data.endDate);
            }

            setMessage(response.data.message);
        } catch (error) {
            console.error("Error verifying license key:", error);
            setMessage(error.response?.data?.message || "Error verifying license key.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={standalone ? "mt-6" : "mt-6 border-t border-gray-300 pt-4"}>
            {!standalone && (
                <>
                    <h6 className="md:text-lg">{t("payment.licenseKeyExistingHeading")}</h6>
                    <p className="text-sm text-gray-600">
                        {t("payment.licenseKeyExistingSubtext")}
                    </p>
                </>
            )}
            <div className="flex flex-col sm:flex-row gap-2 mt-2">
                <input
                    type="text"
                    value={licenseKey}
                    onChange={(e) => setLicenseKey(e.target.value)}
                    placeholder={t("payment.licenseKeyPlaceholder")}
                    className="w-full sm:flex-1 border border-primary rounded px-3 py-2"
                />
                <Button
                    disabled={loading}
                    isLoading={loading}
                    onClick={handleVerifyKey}
                    className="sm:w-40"
                >
                    {t("payment.licenseKeyVerifyButton")}
                </Button>
            </div>
            {message && <p className="mt-2 text-sm">{message}</p>}
        </div>
    );
};

export default LicenseKeyInput;